import { tokenDestinationCard } from "./TokenDestinationCard";

export const AttentiveDestinationCard = tokenDestinationCard({
  type: "attentive",
  intro:
    "Purchase, add-to-cart and product-view events to Attentive from our server, so SMS journeys trigger on " +
    "what actually happened rather than on what the browser managed to report. In Attentive, open Integrations, " +
    "then Create App, name it, and set the eCommerce permission to Write before you create it. Every permission " +
    "on a new app starts at No Access, so a key created without that step is valid and still cannot send events.",
  fields: [
    {
      key: "apiKey",
      label: "Private app API key",
      secret: true,
      helpText:
        "Copy it from the dialog shown right after you create the app. That dialog is the only time Attentive " +
        "shows the key.",
    },
  ],
  testNote:
    "Send test event posts one product view, never a purchase, and deliberately without a phone number, so no " +
    "text can be triggered by it. It does reach your real Attentive account and will create or match a profile " +
    "on a synthetic email address, which you may want to delete afterwards. Worth checking before you turn this " +
    "on: if an Attentive journey already triggers on a Shopify purchase, this sends a second signal for the " +
    "same order and a customer can get two messages. Attentive gives these events no ID, so we cannot deduplicate " +
    "them for you.",
});
